import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { AUTH_MODE } from '@/auth/authMode';
import { Spinner } from '@/components/ui/Spinner';

/**
 * Gate for authenticated areas. Never signs in automatically: unauthenticated
 * visitors are sent to the public sign-in screen (/login in Cognito mode,
 * /signin for the local credential form), where sign-in is an explicit click.
 * Auth errors also land on /login, which displays them.
 */
export function ProtectedRoute() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <Spinner label="Loading" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={AUTH_MODE === 'local' ? '/signin' : '/login'} replace />;
  }

  return <Outlet />;
}
